import React, { useState, useEffect } from 'react';
import {
    Topbar,
} from '@components';
import { useNavigate, useParams } from 'react-router-dom';
import {
    RootContainer,
    Title,
    Top,
    Image,
    Loader,
} from './TopWinners.style';
import { Spin, Table } from 'antd';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { api } from '@api';
import {
    BURMESE_LANGUAGE_CODE_LK,
    CHINESE_LANGUAGE_CODE_LK,
} from '@constants';
import { useSelector } from 'react-redux';
import { getFormattedNumber } from '@utils';
import { useTranslation } from 'react-i18next';

const _data = [
    {
        "user_id": "usr-00000-00000-00000-00000",
        "num": 0,
        "name": "Dummy Name",
        "amount": 1000000,
        "phone": "********000"
    },
    {
        "user_id": "usr-00000-00000-00000-00000",
        "num": 0,
        "name": "Dummy Name",
        "amount": 1000000,
        "phone": "********000"
    },
    {
        "user_id": "usr-00000-00000-00000-00000",
        "num": 0,
        "name": "Dummy Name",
        "amount": 1000000,
        "phone": "********000"
    },
    {
        "user_id": "usr-00000-00000-00000-00000",
        "num": 0,
        "name": "Dummy Name",
        "amount": 1000000,
        "phone": "********000"
    },
];

const TopWinners = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const { child_game_id } = useParams();
    const lang = useSelector(state => state.app.userPreferedLanguage);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(_data);
    const [game, setGame] = useState({});

    useEffect(() => {
        getWinners();

        // eslint-disable-next-line
    }, []);

    const getWinners = () => {
        setLoading(true);
        api
            .getWinners({
                child_game_id,
            })
            .then(({ winners, child_game }) => {
                setLoading(false);
                const _game = parseData([{ ...child_game }])[0];
                setGame(_game);
                setData(winners);
            })
            .catch(() => { });
    }

    /**
     * get game names and icons 
     * based on current app language
     */
    const parseData = (games) => {
        return games.map(item => {
            return {
                ...item,
                icon: lang === CHINESE_LANGUAGE_CODE_LK
                    ? item.icon_ch
                    : lang === BURMESE_LANGUAGE_CODE_LK
                        ? item.icon_mm
                        : item.icon_en,
                name: lang === CHINESE_LANGUAGE_CODE_LK
                    ? item.name_ch
                    : lang === BURMESE_LANGUAGE_CODE_LK
                        ? item.name_mm
                        : item.name_en,
            }
        });
    }

    const goBack = () => {
        navigate(`/${PUBLIC_ROUTE.HOME}`);
    }

    const renderTop = () => (
        <Top>
            <Image src={game.icon} />
            <div>{game.name}</div>
        </Top>
    );

    const columns = [
        {
            key: 'key',
            title: t("topWinner.topWinnerTableHeadingNo"),
            align: 'center',
            render: (_, record, index) => index + 1,
        },
        {
            key: 'name',
            dataIndex: 'name',
            title: t("topWinner.topWinnerTableHeadingName"),
            align: 'center',
        },
        {
            key: 'amount',
            dataIndex: 'amount',
            title: t("topWinner.topWinnerTableHeadingAmount"),
            align: 'center',
            render: (_, record) => getFormattedNumber(record.amount),
        },
        {
            key: 'phone',
            dataIndex: 'phone',
            title: t("topWinner.topWinnerTableHeadingPhone"),
            align: 'center',
        },
    ];

    return (
        <>
            <Topbar
                title={t("topWinner.topWinnerTitle")}
                goBack={goBack}
            />
            <RootContainer>
                {loading && (
                    <Loader>
                        <Spin />
                    </Loader>
                )}
                {!loading &&
                    <>
                        {renderTop()}
                        <Title>
                            {t("topWinner.topWinnerSubtitle")}
                        </Title>
                        <Table
                            size='small'
                            dataSource={data}
                            columns={columns}
                            pagination={false}
                        />
                    </>
                }
            </RootContainer>
        </>
    );
}

export default TopWinners;